import { useState, useEffect } from 'react';

const useSubmitAssignment = (getSocket, onMessageCallback) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const submitAssignment = (assignmentData) => {
    
    // Get the latest socket reference
    const socket = typeof getSocket === 'function' ? getSocket() : getSocket;
    

    if (!socket) {
      setError("WebSocket is not connected.");
      setIsLoading(false);
      return false;
    }

    if (socket.readyState !== WebSocket.OPEN) {
      setError("WebSocket is not ready. Please try again.");
      setIsLoading(false);
      return false;
    }

    setIsLoading(true);
    setError(null);

    try {
      socket.send(JSON.stringify(assignmentData));
      return true;
    } catch (error) {
      setError("Failed to send data: " + error.message);
      setIsLoading(false);
      return false;
    }
  };

  
  return { isLoading, error, submitAssignment };
};

export default useSubmitAssignment;
